<template>
  <tr>
    <td></td>
    <td>
      <v-text-field
        v-model="filterItem.certificate__certificate_number__istartswith"
        outlined
        dense
        clearable
        @change="onChange"
        :clear-icon-cb="onChange"
      ></v-text-field>
    </td>
    <td>
      <v-text-field
        v-model="filterItem.customs_type__name_tc__istartswith"
        outlined
        dense
        clearable
        @change="onChange"
        :clear-icon-cb="onChange"
      ></v-text-field>
    </td>
    <td>
      <v-text-field
        v-model="filterItem.accreditation_number__istartswith"
        outlined
        dense
        clearable
        @change="onChange"
        :clear-icon-cb="onChange"
      ></v-text-field>
    </td>
    <td></td>
  </tr>
</template>
<script>
import BaseFilter from "./BaseFilter";
export default {
  data: (vm) => ({}),
  mixins: [BaseFilter],
  methods: {},
};
</script>